module.exports = __webpack_public_path__ + "static/media/battery-full.c42bd509.svg";